module.exports = __webpack_public_path__ + "img/cvhpgMYd.df6775f2.svg";